// import React, {
//   useEffect,
//   useState,
//   useMemo
// } from "react";

// import axiosAuth from "../../api/axiosAuth";
// import { useAuth } from "../../context/AuthContext";

// import "../../style/AutoevaluacionGestion.css";

// export default function AutoevaluacionGestion() {

//   const { user } = useAuth();

//   /* ==================================================
//      TABS
//   ================================================== */

//   const [tab, setTab] =
//     useState("encuestas");

//   /* ==================================================
//      LOADING
//   ================================================== */

//   const [loading, setLoading] =
//     useState(false);

//   /* ==================================================
//      ENCUESTAS
//   ================================================== */

//   const [encuestas, setEncuestas] =
//     useState([]);

//   const [encuestaSeleccionada,
//     setEncuestaSeleccionada] =
//     useState("");

//   const [nuevaEncuesta,
//     setNuevaEncuesta] =
//     useState({
//       nombre: "",
//       descripcion: "",
//       fecha_inicio: "",
//       fecha_fin: ""
//     });

//   /* ==================================================
//      CATEGORIAS
//   ================================================== */

//   const [categorias,
//     setCategorias] =
//     useState([]);

//   const [nuevaCategoria,
//     setNuevaCategoria] =
//     useState("");

//   /* ==================================================
//      PREGUNTAS
//   ================================================== */

//   const [preguntas,
//     setPreguntas] =
//     useState([]);

//   const [nuevaPregunta,
//     setNuevaPregunta] =
//     useState({
//       encuesta_id: "",
//       categoria_id: "",
//       pregunta: "",
//       orden: 1
//     });

//   /* ==================================================
//      REPORTES
//   ================================================== */

//   const [reporte,
//     setReporte] =
//     useState([]);

//   const [participacion,
//     setParticipacion] =
//     useState({
//       participantes: 0,
//       total: 0,
//       porcentaje: 0
//     });

//   /* ==================================================
//      INIT
//   ================================================== */

//   useEffect(() => {
//     cargarEncuestas();
//     cargarCategorias();
//   }, []);

//   /* ==================================================
//      ENCUESTAS
//   ================================================== */

//   const cargarEncuestas =
//     async () => {

//     try {

//       const { data } =
//         await axiosAuth.get(
//           "/autoevaluacion/encuestas"
//         );

//       setEncuestas(
//         Array.isArray(data)
//           ? data
//           : []
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error cargando encuestas"
//       );
//     }
//   };

//   const crearEncuesta =
//     async () => {

//     try {

//       if (
//         !nuevaEncuesta.nombre ||
//         !nuevaEncuesta.fecha_inicio ||
//         !nuevaEncuesta.fecha_fin
//       ) {
//         return alert(
//           "Complete todos los campos"
//         );
//       }

//       setLoading(true);

//       await axiosAuth.post(
//         "/autoevaluacion/encuestas",
//         nuevaEncuesta
//       );

//       alert(
//         "Encuesta creada correctamente"
//       );

//       setNuevaEncuesta({
//         nombre: "",
//         descripcion: "",
//         fecha_inicio: "",
//         fecha_fin: ""
//       });

//       await cargarEncuestas();

//     } catch (error) {

//       console.error(error);

//       alert(
//         error?.response?.data?.message ||
//         "Error creando encuesta"
//       );

//     } finally {

//       setLoading(false);
//     }
//   };

//   const eliminarEncuesta =
//     async (id) => {

//     try {

//       const ok =
//         window.confirm(
//           "¿Eliminar encuesta?"
//         );

//       if (!ok) return;

//       await axiosAuth.delete(
//         `/autoevaluacion/encuestas/${id}`
//       );

//       await cargarEncuestas();

//       alert(
//         "Encuesta eliminada"
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error eliminando encuesta"
//       );
//     }
//   };

//   /* ==================================================
//      CATEGORIAS
//   ================================================== */

//   const cargarCategorias =
//     async () => {

//     try {

//       const { data } =
//         await axiosAuth.get(
//           "/autoevaluacion/categorias"
//         );

//       setCategorias(
//         Array.isArray(data)
//           ? data
//           : []
//       );

//     } catch (error) {

//       console.error(error);
//     }
//   };

//   const crearCategoria =
//     async () => {

//     try {

//       if (!nuevaCategoria.trim()) {
//         return alert(
//           "Digite una categoría"
//         );
//       }

//       await axiosAuth.post(
//         "/autoevaluacion/categorias",
//         {
//           nombre:
//             nuevaCategoria
//         }
//       );

//       setNuevaCategoria("");

//       await cargarCategorias();

//       alert(
//         "Categoría creada"
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error creando categoría"
//       );
//     }
//   };

//   /* ==================================================
//      PREGUNTAS
//   ================================================== */

//   const cargarPreguntas =
//     async (encuesta_id) => {

//     try {

//       if (!encuesta_id) {

//         setPreguntas([]);
//         return;
//       }

//       const { data } =
//         await axiosAuth.get(
//           `/autoevaluacion/encuestas/${encuesta_id}`
//         );

//       setPreguntas(
//         data?.preguntas || []
//       );

//     } catch (error) {

//       console.error(error);
//     }
//   };

//   useEffect(() => {

//     if (
//       encuestaSeleccionada
//     ) {

//       cargarPreguntas(
//         encuestaSeleccionada
//       );
//     }

//   }, [encuestaSeleccionada]);


//     /* ==================================================
//      CREAR PREGUNTA
//   ================================================== */

//   const crearPregunta =
//     async () => {

//     try {

//       if (
//         !nuevaPregunta.encuesta_id ||
//         !nuevaPregunta.categoria_id ||
//         !nuevaPregunta.pregunta
//       ) {
//         return alert(
//           "Complete todos los campos"
//         );
//       }

//       setLoading(true);

//       await axiosAuth.post(
//         "/autoevaluacion/preguntas",
//         nuevaPregunta
//       );

//       alert(
//         "Pregunta creada correctamente"
//       );

//       setNuevaPregunta({
//         encuesta_id:
//           nuevaPregunta.encuesta_id,
//         categoria_id: "",
//         pregunta: "",
//         orden: 1
//       });

//       await cargarPreguntas(
//         nuevaPregunta.encuesta_id
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         error?.response?.data?.message ||
//         "Error creando pregunta"
//       );

//     } finally {

//       setLoading(false);
//     }
//   };

//   /* ==================================================
//      ELIMINAR PREGUNTA
//   ================================================== */

//   const eliminarPregunta =
//     async (id) => {

//     try {

//       const ok =
//         window.confirm(
//           "¿Eliminar pregunta?"
//         );

//       if (!ok) return;

//       await axiosAuth.delete(
//         `/autoevaluacion/preguntas/${id}`
//       );

//       await cargarPreguntas(
//         encuestaSeleccionada
//       );

//       alert(
//         "Pregunta eliminada"
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error eliminando pregunta"
//       );
//     }
//   };

//   /* ==================================================
//      REPORTES
//   ================================================== */

//   const cargarReporte =
//     async (encuesta_id) => {

//     try {

//       if (!encuesta_id) {
//         return;
//       }

//       const [
//         reporteRes,
//         participacionRes
//       ] = await Promise.all([

//         axiosAuth.get(
//           `/autoevaluacion/reporte/${encuesta_id}`
//         ),

//         axiosAuth.get(
//           `/autoevaluacion/participacion/${encuesta_id}`
//         )

//       ]);

//       setReporte(
//         Array.isArray(
//           reporteRes.data
//         )
//           ? reporteRes.data
//           : []
//       );

//       setParticipacion(
//         participacionRes.data || {
//           participantes: 0,
//           total: 0,
//           porcentaje: 0
//         }
//       );

//     } catch (error) {

//       console.error(error);

//       alert(
//         "Error cargando reporte"
//       );
//     }
//   };

//   useEffect(() => {

//     if (
//       tab === "reportes" &&
//       encuestaSeleccionada
//     ) {

//       cargarReporte(
//         encuestaSeleccionada
//       );
//     }

//   }, [
//     tab,
//     encuestaSeleccionada
//   ]);

//   /* ==================================================
//      MEMOS
//   ================================================== */

//   const encuestaActual =
//     useMemo(() => {

//       return encuestas.find(
//         e =>
//           String(e.id) ===
//           String(
//             encuestaSeleccionada
//           )
//       );

//     }, [
//       encuestas,
//       encuestaSeleccionada
//     ]);

//   const totalPreguntas =
//     useMemo(() => {

//       return preguntas.length;

//     }, [preguntas]);

//   const totalCategorias =
//     useMemo(() => {

//       return categorias.length;

//     }, [categorias]);

//   const promedioGeneral =
//     useMemo(() => {

//       if (!reporte.length) {
//         return 0;
//       }

//       const suma =
//         reporte.reduce(
//           (acc, item) =>
//             acc +
//             Number(
//               item.promedio || 0
//             ),
//           0
//         );

//       return (
//         suma /
//         reporte.length
//       ).toFixed(2);

//     }, [reporte]);

//   const limpiarFormularioPregunta =
//     () => {

//       setNuevaPregunta({
//         encuesta_id:
//           encuestaSeleccionada,
//         categoria_id: "",
//         pregunta: "",
//         orden: 1
//       });
//     };

//   const seleccionarEncuesta =
//     (id) => {

//       setEncuestaSeleccionada(id);

//       setNuevaPregunta(
//         prev => ({
//           ...prev,
//           encuesta_id: id
//         })
//       );
//     };

//   const formatFecha =
//     fecha => {

//       if (!fecha) return "";

//       return new Date(
//         fecha
//       ).toLocaleDateString(
//         "es-CO"
//       );
//     };
//       return (
//     <div className="director-container">

//         <div className="director-card">

//   <h3>
//     📖 Manual de Uso del Módulo de Autoevaluación
//   </h3>

//   <p>
//     El módulo de Autoevaluación Institucional permite medir la percepción,
//     satisfacción y opinión de los diferentes actores de la comunidad educativa
//     (estudiantes, docentes, padres de familia, coordinadores y directivos)
//     mediante encuestas estructuradas.
//   </p>

//   <br />

//   <h4>1️⃣ Encuestas</h4>

//   <p>
//     Una encuesta es el formulario principal que será respondido por los usuarios.
//     Aquí se define el nombre de la evaluación, descripción, fecha de inicio
//     y fecha de cierre.
//   </p>

//   <p>
//     Ejemplos:
//   </p>

//   <ul>
//     <li>Evaluación del Servicio Educativo 2026</li>
//     <li>Satisfacción de Padres de Familia</li>
//     <li>Clima Escolar Institucional</li>
//     <li>Evaluación Docente</li>
//   </ul>

//   <hr />

//   <h4>2️⃣ Categorías</h4>

//   <p>
//     Las categorías sirven para organizar las preguntas por temas específicos.
//     Posteriormente los reportes mostrarán promedios por categoría para facilitar
//     el análisis institucional.
//   </p>

//   <p>
//     Ejemplos de categorías:
//   </p>

//   <ul>
//     <li>Gestión Académica</li>
//     <li>Convivencia Escolar</li>
//     <li>Infraestructura</li>
//     <li>Atención Administrativa</li>
//     <li>Bienestar Estudiantil</li>
//     <li>Desempeño Docente</li>
//   </ul>

//   <hr />

//   <h4>3️⃣ Preguntas</h4>

//   <p>
//     Cada categoría contiene una o varias preguntas que serán respondidas por
//     los participantes usando una escala de valoración.
//   </p>

//   <p>
//     Ejemplos:
//   </p>

//   <ul>
//     <li>Los docentes explican claramente los temas.</li>
//     <li>Las instalaciones son adecuadas para el aprendizaje.</li>
//     <li>Existe buena comunicación con la institución.</li>
//     <li>Me siento seguro dentro de la institución.</li>
//   </ul>

//   <hr />

//   <h4>4️⃣ Participación</h4>

//   <p>
//     La participación muestra cuántos usuarios han respondido la encuesta en
//     comparación con el total de personas habilitadas para responderla.
//   </p>

//   <p>
//     Esto permite identificar el nivel de compromiso de la comunidad educativa.
//   </p>

//   <hr />

//   <h4>5️⃣ Reportes</h4>

//   <p>
//     Los reportes consolidan todas las respuestas recibidas y calculan promedios
//     por categoría.
//   </p>

//   <p>
//     Entre más alto sea el promedio, mejor es la percepción de los usuarios
//     respecto al tema evaluado.
//   </p>

//   <ul>
//     <li>4.5 - 5.0 = Excelente</li>
//     <li>4.0 - 4.4 = Muy Bueno</li>
//     <li>3.0 - 3.9 = Aceptable</li>
//     <li>1.0 - 2.9 = Requiere Mejoramiento</li>
//   </ul>

//   <hr />

//   <h4>🎯 Recomendación Institucional</h4>

//   <p>
//     Se recomienda crear primero las categorías, luego las encuestas y finalmente
//     las preguntas asociadas a cada categoría. Una vez finalizada la aplicación
//     de la encuesta, los reportes permitirán identificar fortalezas,
//     oportunidades de mejora y planes de mejoramiento institucional.
//   </p>



//         <h2>
//           📋 Autoevaluación Institucional
//         </h2>

//         <p>
//           Usuario:
//           {" "}
//           <strong>
//             {user?.nombre}
//             {" "}
//             {user?.apellido}
//           </strong>
//         </p>

//       </div>

//       {/* ==========================================
//           TABS
//       ========================================== */}

//       <div className="director-card">

//         <button
//           onClick={() =>
//             setTab("encuestas")
//           }
//         >
//           Encuestas
//         </button>

//         <button
//           onClick={() =>
//             setTab("categorias")
//           }
//         >
//           Categorías
//         </button>

//         <button
//           onClick={() =>
//             setTab("preguntas")
//           }
//         >
//           Preguntas
//         </button>

//         <button
//           onClick={() =>
//             setTab("reportes")
//           }
//         >
//           Reportes
//         </button>

//       </div>

//       {/* ==========================================
//           ENCUESTAS
//       ========================================== */}

//       {tab === "encuestas" && (

//         <div className="director-card">

//           <h3>
//             Crear Encuesta
//           </h3>

//           <input
//             type="text"
//             placeholder="Nombre"
//             value={nuevaEncuesta.nombre}
//             onChange={(e) =>
//               setNuevaEncuesta({
//                 ...nuevaEncuesta,
//                 nombre: e.target.value
//               })
//             }
//           />

//           <textarea
//             placeholder="Descripción"
//             value={
//               nuevaEncuesta.descripcion
//             }
//             onChange={(e) =>
//               setNuevaEncuesta({
//                 ...nuevaEncuesta,
//                 descripcion:
//                   e.target.value
//               })
//             }
//           />

//           <input
//             type="date"
//             value={
//               nuevaEncuesta.fecha_inicio
//             }
//             onChange={(e) =>
//               setNuevaEncuesta({
//                 ...nuevaEncuesta,
//                 fecha_inicio:
//                   e.target.value
//               })
//             }
//           />

//           <input
//             type="date"
//             value={
//               nuevaEncuesta.fecha_fin
//             }
//             onChange={(e) =>
//               setNuevaEncuesta({
//                 ...nuevaEncuesta,
//                 fecha_fin:
//                   e.target.value
//               })
//             }
//           />

//           <button
//             onClick={
//               crearEncuesta
//             }
//             disabled={loading}
//           >
//             Guardar Encuesta
//           </button>

//           <hr />

//           <h3>
//             Encuestas Registradas
//           </h3>

//           <table>

//             <thead>
//               <tr>
//                 <th>ID</th>
//                 <th>Nombre</th>
//                 <th>Inicio</th>
//                 <th>Fin</th>
//                 <th>Activa</th>
//                 <th></th>
//               </tr>
//             </thead>

//             <tbody>

//               {encuestas.map(
//                 encuesta => (

//                   <tr
//                     key={encuesta.id}
//                   >
//                     <td>
//                       {encuesta.id}
//                     </td>

//                     <td>
//                       {encuesta.nombre}
//                     </td>

//                     <td>
//                       {formatFecha(
//                         encuesta.fecha_inicio
//                       )}
//                     </td>

//                     <td>
//                       {formatFecha(
//                         encuesta.fecha_fin
//                       )}
//                     </td>

//                     <td>
//                       {encuesta.activa
//                         ? "SI"
//                         : "NO"}
//                     </td>

//                     <td>

//                       <button
//                         onClick={() =>
//                           seleccionarEncuesta(
//                             encuesta.id
//                           )
//                         }
//                       >
//                         Seleccionar
//                       </button>

//                       <button
//                         onClick={() =>
//                           eliminarEncuesta(
//                             encuesta.id
//                           )
//                         }
//                       >
//                         Eliminar
//                       </button>

//                     </td>

//                   </tr>

//                 )
//               )}

//             </tbody>

//           </table>

//         </div>

//       )}

//       {/* ==========================================
//           CATEGORIAS
//       ========================================== */}

//       {tab === "categorias" && (

//         <div className="director-card">

//           <h3>
//             Categorías
//           </h3>

//           <input
//             type="text"
//             placeholder="Nueva categoría"
//             value={nuevaCategoria}
//             onChange={(e) =>
//               setNuevaCategoria(
//                 e.target.value
//               )
//             }
//           />

//           <button
//             onClick={
//               crearCategoria
//             }
//           >
//             Crear Categoría
//           </button>

//           <hr />

//           <table>

//             <thead>
//               <tr>
//                 <th>ID</th>
//                 <th>Nombre</th>
//               </tr>
//             </thead>

//             <tbody>

//               {categorias.map(
//                 categoria => (

//                   <tr
//                     key={categoria.id}
//                   >
//                     <td>
//                       {categoria.id}
//                     </td>

//                     <td>
//                       {categoria.nombre}
//                     </td>
//                   </tr>

//                 )
//               )}

//             </tbody>

//           </table>

//         </div>

//       )}

//       {/* ==========================================
//           PREGUNTAS
//       ========================================== */}

//       {tab === "preguntas" && (

//         <div className="director-card">

//           <h3>
//             Gestión de Preguntas
//           </h3>

//           <select
//             value={
//               nuevaPregunta.encuesta_id
//             }
//             onChange={(e) =>
//               setNuevaPregunta({
//                 ...nuevaPregunta,
//                 encuesta_id:
//                   e.target.value
//               })
//             }
//           >

//             <option value="">
//               Seleccione encuesta
//             </option>

//             {encuestas.map(
//               encuesta => (
//                 <option
//                   key={encuesta.id}
//                   value={encuesta.id}
//                 >
//                   {encuesta.nombre}
//                 </option>
//               )
//             )}

//           </select>

//           <select
//             value={
//               nuevaPregunta.categoria_id
//             }
//             onChange={(e) =>
//               setNuevaPregunta({
//                 ...nuevaPregunta,
//                 categoria_id:
//                   e.target.value
//               })
//             }
//           >

//             <option value="">
//               Categoría
//             </option>

//             {categorias.map(
//               categoria => (
//                 <option
//                   key={categoria.id}
//                   value={categoria.id}
//                 >
//                   {categoria.nombre}
//                 </option>
//               )
//             )}

//           </select>

//           <textarea
//             placeholder="Pregunta"
//             value={
//               nuevaPregunta.pregunta
//             }
//             onChange={(e) =>
//               setNuevaPregunta({
//                 ...nuevaPregunta,
//                 pregunta:
//                   e.target.value
//               })
//             }
//           />

//           <input
//             type="number"
//             min="1"
//             value={
//               nuevaPregunta.orden
//             }
//             onChange={(e) =>
//               setNuevaPregunta({
//                 ...nuevaPregunta,
//                 orden:
//                   e.target.value
//               })
//             }
//           />

//           <button
//             onClick={
//               crearPregunta
//             }
//           >
//             Guardar Pregunta
//           </button>

//           <hr />

//           <h4>
//             Preguntas
//           </h4>

//           <p>
//             Encuesta:
//             {" "}
//             <strong>
//               {encuestaActual?.nombre ||
//                 "No seleccionada"}
//             </strong>
//           </p>

//           <p>
//             Total preguntas:
//             {" "}
//             {totalPreguntas}
//           </p>

//           <table>

//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>Categoría</th>
//                 <th>Pregunta</th>
//                 <th></th>
//               </tr>
//             </thead>

//             <tbody>

//               {preguntas.map(
//                 pregunta => (

//                   <tr
//                     key={pregunta.id}
//                   >
//                     <td>
//                       {pregunta.orden}
//                     </td>

//                     <td>
//                       {pregunta.categoria}
//                     </td>

//                     <td>
//                       {pregunta.pregunta}
//                     </td>

//                     <td>

//                       <button
//                         onClick={() =>
//                           eliminarPregunta(
//                             pregunta.id
//                           )
//                         }
//                       >
//                         Eliminar
//                       </button>

//                     </td>

//                   </tr>

//                 )
//               )}

//             </tbody>

//           </table>

//         </div>

//       )}

//       {/* ==========================================
//           REPORTES
//       ========================================== */}

//       {tab === "reportes" && (

//         <div className="director-card">

//           <h3>
//             Reporte General
//           </h3>

//           <select
//             value={
//               encuestaSeleccionada
//             }
//             onChange={(e) =>
//               setEncuestaSeleccionada(
//                 e.target.value
//               )
//             }
//           >

//             <option value="">
//               Seleccione encuesta
//             </option>

//             {encuestas.map(
//               encuesta => (
//                 <option
//                   key={encuesta.id}
//                   value={encuesta.id}
//                 >
//                   {encuesta.nombre}
//                 </option>
//               )
//             )}

//           </select>

//           <hr />

//           <h4>
//             Participación
//           </h4>

//           <p>
//             Participantes:
//             {" "}
//             {participacion.participantes}
//           </p>

//           <p>
//             Total:
//             {" "}
//             {participacion.total}
//           </p>

//           <p>
//             Porcentaje:
//             {" "}
//             {participacion.porcentaje}
//             %
//           </p>

//           <h4>
//             Promedio General:
//             {" "}
//             {promedioGeneral}
//           </h4>

//           <table>

//             <thead>
//               <tr>
//                 <th>Categoría</th>
//                 <th>Promedio</th>
//                 <th>Respuestas</th>
//               </tr>
//             </thead>

//             <tbody>

//               {reporte.map(
//                 item => (

//                   <tr
//                     key={
//                       item.categoria_id
//                     }
//                   >
//                     <td>
//                       {item.categoria}
//                     </td>

//                     <td>
//                       {item.promedio}
//                     </td>

//                     <td>
//                       {item.respuestas}
//                     </td>

//                   </tr>

//                 )
//               )}

//             </tbody>

//           </table>

//         </div>

//       )}

//     </div>
//   );
// }


//

import React, {
  useEffect,
  useState,
  useMemo
} from "react";

import axiosAuth from "../../api/axiosAuth";
import { useAuth } from "../../context/AuthContext";

import "../../style/AutoevaluacionGestion.css";

export default function AutoevaluacionGestion() {

  const { user } = useAuth();

  /* ==================================================
     TABS
  ================================================== */

  const [tab, setTab] =
    useState("encuestas");

  /* ==================================================
     LOADING
  ================================================== */

  const [loading, setLoading] =
    useState(false);

  /* ==================================================
     ENCUESTAS
  ================================================== */

  const [encuestas, setEncuestas] =
    useState([]);

  const [encuestaSeleccionada,
    setEncuestaSeleccionada] =
    useState("");

  const [nuevaEncuesta,
    setNuevaEncuesta] =
    useState({
      nombre: "",
      descripcion: "",
      fecha_inicio: "",
      fecha_fin: ""
    });

  /* ==================================================
     CATEGORIAS
  ================================================== */

  const [categorias,
    setCategorias] =
    useState([]);

  const [nuevaCategoria,
    setNuevaCategoria] =
    useState("");

  /* ==================================================
     PREGUNTAS
  ================================================== */

  const [preguntas,
    setPreguntas] =
    useState([]);

  const [nuevaPregunta,
    setNuevaPregunta] =
    useState({
      encuesta_id: "",
      categoria_id: "",
      pregunta: "",
      orden: 1
    });

  /* ==================================================
     REPORTES
  ================================================== */

  const [reporte,
    setReporte] =
    useState([]);

  const [participacion,
    setParticipacion] =
    useState({
      participantes: 0,
      total: 0,
      porcentaje: 0
    });

  /* ==================================================
     INIT
  ================================================== */

  useEffect(() => {
    cargarEncuestas();
    cargarCategorias();
  }, []);

  /* ==================================================
     ENCUESTAS
  ================================================== */

  const cargarEncuestas =
    async () => {

    try {

      const { data } =
        await axiosAuth.get(
          "/autoevaluacion/encuestas"
        );

      // 🔧 CORREGIDO: el backend devuelve { ok, total, encuestas }
      const lista = Array.isArray(data?.encuestas)
        ? data.encuestas
        : Array.isArray(data)
          ? data
          : [];

      setEncuestas(lista);

    } catch (error) {

      console.error(error);

      alert(
        "Error cargando encuestas"
      );
    }
  };

  const crearEncuesta =
    async () => {

    try {

      if (
        !nuevaEncuesta.nombre ||
        !nuevaEncuesta.fecha_inicio ||
        !nuevaEncuesta.fecha_fin
      ) {
        return alert(
          "Complete todos los campos"
        );
      }

      setLoading(true);

      await axiosAuth.post(
        "/autoevaluacion/encuestas",
        nuevaEncuesta
      );

      alert(
        "Encuesta creada correctamente"
      );

      setNuevaEncuesta({
        nombre: "",
        descripcion: "",
        fecha_inicio: "",
        fecha_fin: ""
      });

      await cargarEncuestas();

    } catch (error) {

      console.error(error);

      alert(
        error?.response?.data?.message ||
        "Error creando encuesta"
      );

    } finally {

      setLoading(false);
    }
  };

  const eliminarEncuesta =
    async (id) => {

    try {

      const ok =
        window.confirm(
          "¿Eliminar encuesta?"
        );

      if (!ok) return;

      await axiosAuth.delete(
        `/autoevaluacion/encuestas/${id}`
      );

      await cargarEncuestas();

      alert(
        "Encuesta eliminada"
      );

    } catch (error) {

      console.error(error);

      alert(
        "Error eliminando encuesta"
      );
    }
  };

  /* ==================================================
     CATEGORIAS
  ================================================== */

  const cargarCategorias =
    async () => {

    try {

      const { data } =
        await axiosAuth.get(
          "/autoevaluacion/categorias"
        );

      // 🔧 CORREGIDO: el backend devuelve { ok, total, categorias }
      const lista = Array.isArray(data?.categorias)
        ? data.categorias
        : Array.isArray(data)
          ? data
          : [];

      setCategorias(lista);

    } catch (error) {

      console.error(error);
    }
  };

  const crearCategoria =
    async () => {

    try {

      if (!nuevaCategoria.trim()) {
        return alert(
          "Digite una categoría"
        );
      }

      await axiosAuth.post(
        "/autoevaluacion/categorias",
        {
          nombre:
            nuevaCategoria
        }
      );

      setNuevaCategoria("");

      await cargarCategorias();

      alert(
        "Categoría creada"
      );

    } catch (error) {

      console.error(error);

      alert(
        error?.response?.data?.message ||
        "Error creando categoría"
      );
    }
  };

  /* ==================================================
     PREGUNTAS
  ================================================== */

  const cargarPreguntas =
    async (encuesta_id) => {

    try {

      if (!encuesta_id) {

        setPreguntas([]);
        return;
      }

      const { data } =
        await axiosAuth.get(
          `/autoevaluacion/encuestas/${encuesta_id}`
        );

      // 🔧 CORREGIDO: obtenerEncuesta devuelve
      // { success, encuesta: { ...campos, preguntas: [...] } }
      // las preguntas están anidadas dentro de "encuesta"
      const lista = Array.isArray(data?.encuesta?.preguntas)
        ? data.encuesta.preguntas
        : Array.isArray(data?.preguntas)
          ? data.preguntas
          : [];

      setPreguntas(lista);

    } catch (error) {

      console.error(error);
    }
  };

  useEffect(() => {

    if (
      encuestaSeleccionada
    ) {

      cargarPreguntas(
        encuestaSeleccionada
      );
    }

  }, [encuestaSeleccionada]);


    /* ==================================================
     CREAR PREGUNTA
  ================================================== */

  const crearPregunta =
    async () => {

    try {

      if (
        !nuevaPregunta.encuesta_id ||
        !nuevaPregunta.categoria_id ||
        !nuevaPregunta.pregunta
      ) {
        return alert(
          "Complete todos los campos"
        );
      }

      setLoading(true);

      await axiosAuth.post(
        "/autoevaluacion/preguntas",
        nuevaPregunta
      );

      alert(
        "Pregunta creada correctamente"
      );

      setNuevaPregunta({
        encuesta_id:
          nuevaPregunta.encuesta_id,
        categoria_id: "",
        pregunta: "",
        orden: 1
      });

      await cargarPreguntas(
        nuevaPregunta.encuesta_id
      );

    } catch (error) {

      console.error(error);

      alert(
        error?.response?.data?.msg ||
        error?.response?.data?.message ||
        "Error creando pregunta"
      );

    } finally {

      setLoading(false);
    }
  };

  /* ==================================================
     ELIMINAR PREGUNTA
  ================================================== */

  const eliminarPregunta =
    async (id) => {

    try {

      const ok =
        window.confirm(
          "¿Eliminar pregunta?"
        );

      if (!ok) return;

      await axiosAuth.delete(
        `/autoevaluacion/preguntas/${id}`
      );

      await cargarPreguntas(
        encuestaSeleccionada
      );

      alert(
        "Pregunta eliminada"
      );

    } catch (error) {

      console.error(error);

      alert(
        "Error eliminando pregunta"
      );
    }
  };

  /* ==================================================
     REPORTES
  ================================================== */

  const cargarReporte =
    async (encuesta_id) => {

    try {

      if (!encuesta_id) {
        return;
      }

      const [
        reporteRes,
        participacionRes
      ] = await Promise.all([

        axiosAuth.get(
          `/autoevaluacion/reporte/${encuesta_id}`
        ),

        axiosAuth.get(
          `/autoevaluacion/participacion/${encuesta_id}`
        )

      ]);

      // 🔧 CORREGIDO: reporteGeneral devuelve { ok, reporte: [...] }
      const listaReporte = Array.isArray(reporteRes.data?.reporte)
        ? reporteRes.data.reporte
        : Array.isArray(reporteRes.data)
          ? reporteRes.data
          : [];

      setReporte(listaReporte);

      setParticipacion(
        participacionRes.data || {
          participantes: 0,
          total: 0,
          porcentaje: 0
        }
      );

    } catch (error) {

      console.error(error);

      alert(
        "Error cargando reporte"
      );
    }
  };

  useEffect(() => {

    if (
      tab === "reportes" &&
      encuestaSeleccionada
    ) {

      cargarReporte(
        encuestaSeleccionada
      );
    }

  }, [
    tab,
    encuestaSeleccionada
  ]);

  /* ==================================================
     MEMOS
  ================================================== */

  const encuestaActual =
    useMemo(() => {

      return encuestas.find(
        e =>
          String(e.id) ===
          String(
            encuestaSeleccionada
          )
      );

    }, [
      encuestas,
      encuestaSeleccionada
    ]);

  const totalPreguntas =
    useMemo(() => {

      return preguntas.length;

    }, [preguntas]);

  const totalCategorias =
    useMemo(() => {

      return categorias.length;

    }, [categorias]);

  const promedioGeneral =
    useMemo(() => {

      if (!reporte.length) {
        return 0;
      }

      const suma =
        reporte.reduce(
          (acc, item) =>
            acc +
            Number(
              item.promedio || 0
            ),
          0
        );

      return (
        suma /
        reporte.length
      ).toFixed(2);

    }, [reporte]);

  const limpiarFormularioPregunta =
    () => {

      setNuevaPregunta({
        encuesta_id:
          encuestaSeleccionada,
        categoria_id: "",
        pregunta: "",
        orden: 1
      });
    };

  const seleccionarEncuesta =
    (id) => {

      setEncuestaSeleccionada(id);

      setNuevaPregunta(
        prev => ({
          ...prev,
          encuesta_id: id
        })
      );
    };

  const formatFecha =
    fecha => {

      if (!fecha) return "";

      return new Date(
        fecha
      ).toLocaleDateString(
        "es-CO"
      );
    };
      return (
    <div className="director-container">

        <div className="director-card">

  <h3>
    📖 Manual de Uso del Módulo de Autoevaluación
  </h3>

  <p>
    El módulo de Autoevaluación Institucional permite medir la percepción,
    satisfacción y opinión de los diferentes actores de la comunidad educativa
    (estudiantes, docentes, padres de familia, coordinadores y directivos)
    mediante encuestas estructuradas.
  </p>

  <br />

  <h4>1️⃣ Encuestas</h4>

  <p>
    Una encuesta es el formulario principal que será respondido por los usuarios.
    Aquí se define el nombre de la evaluación, descripción, fecha de inicio
    y fecha de cierre.
  </p>

  <p>
    Ejemplos:
  </p>

  <ul>
    <li>Evaluación del Servicio Educativo 2026</li>
    <li>Satisfacción de Padres de Familia</li>
    <li>Clima Escolar Institucional</li>
    <li>Evaluación Docente</li>
  </ul>

  <hr />

  <h4>2️⃣ Categorías</h4>

  <p>
    Las categorías sirven para organizar las preguntas por temas específicos.
    Posteriormente los reportes mostrarán promedios por categoría para facilitar
    el análisis institucional.
  </p>

  <p>
    Ejemplos de categorías:
  </p>

  <ul>
    <li>Gestión Académica</li>
    <li>Convivencia Escolar</li>
    <li>Infraestructura</li>
    <li>Atención Administrativa</li>
    <li>Bienestar Estudiantil</li>
    <li>Desempeño Docente</li>
  </ul>

  <hr />

  <h4>3️⃣ Preguntas</h4>

  <p>
    Cada categoría contiene una o varias preguntas que serán respondidas por
    los participantes usando una escala de valoración.
  </p>

  <p>
    Ejemplos:
  </p>

  <ul>
    <li>Los docentes explican claramente los temas.</li>
    <li>Las instalaciones son adecuadas para el aprendizaje.</li>
    <li>Existe buena comunicación con la institución.</li>
    <li>Me siento seguro dentro de la institución.</li>
  </ul>

  <hr />

  <h4>4️⃣ Participación</h4>

  <p>
    La participación muestra cuántos usuarios han respondido la encuesta en
    comparación con el total de personas habilitadas para responderla.
  </p>

  <p>
    Esto permite identificar el nivel de compromiso de la comunidad educativa.
  </p>

  <hr />

  <h4>5️⃣ Reportes</h4>

  <p>
    Los reportes consolidan todas las respuestas recibidas y calculan promedios
    por categoría.
  </p>

  <p>
    Entre más alto sea el promedio, mejor es la percepción de los usuarios
    respecto al tema evaluado.
  </p>

  <ul>
    <li>4.5 - 5.0 = Excelente</li>
    <li>4.0 - 4.4 = Muy Bueno</li>
    <li>3.0 - 3.9 = Aceptable</li>
    <li>1.0 - 2.9 = Requiere Mejoramiento</li>
  </ul>

  <hr />

  <h4>🎯 Recomendación Institucional</h4>

  <p>
    Se recomienda crear primero las categorías, luego las encuestas y finalmente
    las preguntas asociadas a cada categoría. Una vez finalizada la aplicación
    de la encuesta, los reportes permitirán identificar fortalezas,
    oportunidades de mejora y planes de mejoramiento institucional.
  </p>



        <h2>
          📋 Autoevaluación Institucional
        </h2>

        <p>
          Usuario:
          {" "}
          <strong>
            {user?.nombre}
            {" "}
            {user?.apellido}
          </strong>
        </p>

      </div>

      {/* ==========================================
          TABS
      ========================================== */}

      <div className="director-card">

        <button
          onClick={() =>
            setTab("encuestas")
          }
        >
          Encuestas
        </button>

        <button
          onClick={() =>
            setTab("categorias")
          }
        >
          Categorías
        </button>

        <button
          onClick={() =>
            setTab("preguntas")
          }
        >
          Preguntas
        </button>

        <button
          onClick={() =>
            setTab("reportes")
          }
        >
          Reportes
        </button>

      </div>

      {/* ==========================================
          ENCUESTAS
      ========================================== */}

      {tab === "encuestas" && (

        <div className="director-card">

          <h3>
            Crear Encuesta
          </h3>

          <input
            type="text"
            placeholder="Nombre"
            value={nuevaEncuesta.nombre}
            onChange={(e) =>
              setNuevaEncuesta({
                ...nuevaEncuesta,
                nombre: e.target.value
              })
            }
          />

          <textarea
            placeholder="Descripción"
            value={
              nuevaEncuesta.descripcion
            }
            onChange={(e) =>
              setNuevaEncuesta({
                ...nuevaEncuesta,
                descripcion:
                  e.target.value
              })
            }
          />

          <input
            type="date"
            value={
              nuevaEncuesta.fecha_inicio
            }
            onChange={(e) =>
              setNuevaEncuesta({
                ...nuevaEncuesta,
                fecha_inicio:
                  e.target.value
              })
            }
          />

          <input
            type="date"
            value={
              nuevaEncuesta.fecha_fin
            }
            onChange={(e) =>
              setNuevaEncuesta({
                ...nuevaEncuesta,
                fecha_fin:
                  e.target.value
              })
            }
          />

          <button
            onClick={
              crearEncuesta
            }
            disabled={loading}
          >
            Guardar Encuesta
          </button>

          <hr />

          <h3>
            Encuestas Registradas
          </h3>

          <table>

            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Inicio</th>
                <th>Fin</th>
                <th>Activa</th>
                <th></th>
              </tr>
            </thead>

            <tbody>

              {encuestas.map(
                encuesta => (

                  <tr
                    key={encuesta.id}
                  >
                    <td>
                      {encuesta.id}
                    </td>

                    <td>
                      {encuesta.nombre}
                    </td>

                    <td>
                      {formatFecha(
                        encuesta.fecha_inicio
                      )}
                    </td>

                    <td>
                      {formatFecha(
                        encuesta.fecha_fin
                      )}
                    </td>

                    <td>
                      {encuesta.activa
                        ? "SI"
                        : "NO"}
                    </td>

                    <td>

                      <button
                        onClick={() =>
                          seleccionarEncuesta(
                            encuesta.id
                          )
                        }
                      >
                        Seleccionar
                      </button>

                      <button
                        onClick={() =>
                          eliminarEncuesta(
                            encuesta.id
                          )
                        }
                      >
                        Eliminar
                      </button>

                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>

      )}

      {/* ==========================================
          CATEGORIAS
      ========================================== */}

      {tab === "categorias" && (

        <div className="director-card">

          <h3>
            Categorías
          </h3>

          <input
            type="text"
            placeholder="Nueva categoría"
            value={nuevaCategoria}
            onChange={(e) =>
              setNuevaCategoria(
                e.target.value
              )
            }
          />

          <button
            onClick={
              crearCategoria
            }
          >
            Crear Categoría
          </button>

          <hr />

          <table>

            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
              </tr>
            </thead>

            <tbody>

              {categorias.map(
                categoria => (

                  <tr
                    key={categoria.id}
                  >
                    <td>
                      {categoria.id}
                    </td>

                    <td>
                      {categoria.nombre}
                    </td>
                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>

      )}

      {/* ==========================================
          PREGUNTAS
      ========================================== */}

      {tab === "preguntas" && (

        <div className="director-card">

          <h3>
            Gestión de Preguntas
          </h3>

          <select
            value={
              nuevaPregunta.encuesta_id
            }
            onChange={(e) =>
              setNuevaPregunta({
                ...nuevaPregunta,
                encuesta_id:
                  e.target.value
              })
            }
          >

            <option value="">
              Seleccione encuesta
            </option>

            {encuestas.map(
              encuesta => (
                <option
                  key={encuesta.id}
                  value={encuesta.id}
                >
                  {encuesta.nombre}
                </option>
              )
            )}

          </select>

          <select
            value={
              nuevaPregunta.categoria_id
            }
            onChange={(e) =>
              setNuevaPregunta({
                ...nuevaPregunta,
                categoria_id:
                  e.target.value
              })
            }
          >

            <option value="">
              Categoría
            </option>

            {categorias.map(
              categoria => (
                <option
                  key={categoria.id}
                  value={categoria.id}
                >
                  {categoria.nombre}
                </option>
              )
            )}

          </select>

          <textarea
            placeholder="Pregunta"
            value={
              nuevaPregunta.pregunta
            }
            onChange={(e) =>
              setNuevaPregunta({
                ...nuevaPregunta,
                pregunta:
                  e.target.value
              })
            }
          />

          <input
            type="number"
            min="1"
            value={
              nuevaPregunta.orden
            }
            onChange={(e) =>
              setNuevaPregunta({
                ...nuevaPregunta,
                orden:
                  e.target.value
              })
            }
          />

          <button
            onClick={
              crearPregunta
            }
          >
            Guardar Pregunta
          </button>

          <hr />

          <h4>
            Preguntas
          </h4>

          <p>
            Encuesta:
            {" "}
            <strong>
              {encuestaActual?.nombre ||
                "No seleccionada"}
            </strong>
          </p>

          <p>
            Total preguntas:
            {" "}
            {totalPreguntas}
          </p>

          <table>

            <thead>
              <tr>
                <th>#</th>
                <th>Categoría</th>
                <th>Pregunta</th>
                <th></th>
              </tr>
            </thead>

            <tbody>

              {preguntas.map(
                pregunta => (

                  <tr
                    key={pregunta.id}
                  >
                    <td>
                      {pregunta.orden}
                    </td>

                    <td>
                      {pregunta.categoria}
                    </td>

                    <td>
                      {pregunta.pregunta}
                    </td>

                    <td>

                      <button
                        onClick={() =>
                          eliminarPregunta(
                            pregunta.id
                          )
                        }
                      >
                        Eliminar
                      </button>

                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>

      )}

      {/* ==========================================
          REPORTES
      ========================================== */}

      {tab === "reportes" && (

        <div className="director-card">

          <h3>
            Reporte General
          </h3>

          <select
            value={
              encuestaSeleccionada
            }
            onChange={(e) =>
              setEncuestaSeleccionada(
                e.target.value
              )
            }
          >

            <option value="">
              Seleccione encuesta
            </option>

            {encuestas.map(
              encuesta => (
                <option
                  key={encuesta.id}
                  value={encuesta.id}
                >
                  {encuesta.nombre}
                </option>
              )
            )}

          </select>

          <hr />

          <h4>
            Participación
          </h4>

          <p>
            Participantes:
            {" "}
            {participacion.participantes}
          </p>

          <p>
            Total:
            {" "}
            {participacion.total}
          </p>

          <p>
            Porcentaje:
            {" "}
            {participacion.porcentaje}
            %
          </p>

          <h4>
            Promedio General:
            {" "}
            {promedioGeneral}
          </h4>

          <table>

            <thead>
              <tr>
                <th>Categoría</th>
                <th>Promedio</th>
                <th>Respuestas</th>
              </tr>
            </thead>

            <tbody>

              {reporte.map(
                item => (

                  <tr
                    key={
                      item.categoria_id
                    }
                  >
                    <td>
                      {item.categoria}
                    </td>

                    <td>
                      {item.promedio}
                    </td>

                    <td>
                      {item.respuestas}
                    </td>

                  </tr>

                )
              )}

            </tbody>

          </table>

        </div>

      )}

    </div>
  );
}